import { getRootCause } from './utils/rootCause.js';
// Note: we use the BaseErrors to capture errors at specific points in the code
//  they can carry addition to help give more context
export class BaseError extends Error {
    constructor(name, code, message, cause) {
        super(message);
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "cause", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.name = name;
        this.code = code;
        this.cause = cause;
        const rootCause = getRootCause(this.cause);
        if (rootCause && rootCause.stack) {
            this.stack = rootCause.stack;
        }
    }
}
//# sourceMappingURL=baseError.js.map